/**
 * 路由定义
 *
 * 结构：
 * /                        → 重定向到 /shelf
 * /shelf                   → 书架
 * /reader/:docId           → 阅读工作台
 * /hump                    → 驼峰（知识点集合）
 * /hump/:type/:itemId      → 知识点详情（type: word|snippet|note）
 * /settings                → 设置（默认重定向到 /settings/display）
 * /settings/display        → 显示与阅读
 * /settings/ai             → AI 配置
 * /settings/account        → 账号与会员（v1.1）
 * /settings/sync           → 同步与备份（v1.1）
 * /settings/voice          → 我的声音（v1.1）
 * *                        → 404
 */

import { createHashRouter, Navigate } from 'react-router';
import { AppShell } from '../components/AppShell';
import { RouteErrorBoundary } from '../components/RouteErrorBoundary';
import { ShelfPage } from '../pages/ShelfPage';
import { ReaderPage } from '../pages/ReaderPage';
import { VocabPage } from '../pages/VocabPage';
import { VocabDetailPage } from '../pages/VocabDetailPage';
import { ReviewPage } from '../pages/ReviewPage';
import { SettingsPage } from '../pages/SettingsPage';
import { AuthPage } from '../pages/AuthPage';

export const router = createHashRouter([
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <Navigate to="/shelf" replace /> },
      { path: 'shelf', element: <RouteErrorBoundary><ShelfPage /></RouteErrorBoundary> },
      { path: 'reader', element: <Navigate to="/shelf" replace /> },
      { path: 'reader/:docId', element: <RouteErrorBoundary><ReaderPage /></RouteErrorBoundary> },
      { path: 'hump', element: <RouteErrorBoundary><VocabPage /></RouteErrorBoundary> },
      { path: 'hump/:type/:itemId', element: <RouteErrorBoundary><VocabDetailPage /></RouteErrorBoundary> },
      { path: 'vocab', element: <Navigate to="/hump" replace /> },
      { path: 'review', element: <RouteErrorBoundary><ReviewPage /></RouteErrorBoundary> },
      {
        path: 'settings',
        children: [
          { index: true, element: <Navigate to="/settings/display" replace /> },
          { path: ':section', element: <RouteErrorBoundary><SettingsPage /></RouteErrorBoundary> },
        ],
      },
      { path: '*', element: <RouteErrorBoundary><NotFoundPage /></RouteErrorBoundary> },
    ],
  },
  {
    path: '/auth',
    element: <RouteErrorBoundary><AuthPage /></RouteErrorBoundary>,
  },
]);

function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-4">
      <p className="text-6xl">🐪</p>
      <p className="text-xl text-charcoal dark:text-charcoal-light">页面不存在</p>
      <a
        href="#/shelf"
        className="text-camel hover:text-camel-dark underline"
      >
        返回书架
      </a>
    </div>
  );
}
